<div
  class="drag-area"
  [style.background-image]="selectedDragItem ? 'url('+selectedDragItem.thumbnail+')' : ''"
  [class.has-item]="!!selectedDragItem"
  [class.on-drag]="onDrag"
  (dragover)="$event.preventDefault()"
  (dragenter)="onDragEnter()"
  (dragleave)="onDragLeave()"
  (drop)="onDrop($event)"
>
  <div class="drag-text">
    <div
      inlineSVG="/assets/icons/autopilot-upload-icon.svg"
      class="plus-sign"
    ></div>
    <div class="inner-text">Drag Here</div>
  </div>
  <div class="trash" (click)="onTrashClick()"></div>
</div>
<label *ngIf="!selectedDragItem"
  >Drag A Graphic Or A Video From Your Media Panel.</label
>
<label *ngIf="selectedDragItem"
  >{{ selectedDragItem.contentType == 0? 'Gfx: ' : 'Media:
  '}}{{selectedDragItem.name }}</label
>
